enum ButtonColorEnum {
    Primary = 'primary',
    Secondary = 'secondary',
    Menu = 'menu',
    MenuDanger = 'menuDanger',
    TablePrimary = 'tablePrimary',
    TableSecondary = 'tableSecondary',
    None = 'none',
    NoneNoDisable = 'NoneNoDisable',
}

export default ButtonColorEnum;
